<div
  class="irembo-image-container"
  [ngStyle]="{
    '--desktop-width': desktopWidth,
    '--tablet-width': tabletWidth,
    '--mobile-width': mobileWidth
  }">
  <img
    [src]="imageSource"
    [alt]="alt"
    [style.object-fit]="objectFit"
    [style.border-radius]="borderRadius"
    class="responsive-image" />
</div>
